import { Component, forwardRef } from "react";
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../utils/pagination";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../actions/fillCombo_action';
import AdminDrawer from "../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import "react-datepicker/dist/react-datepicker.css";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import { getDDReturnList_action, getDDReturnDetails_action, updateDDReturn_action } from "../../../actions/admin_module_action/DD_return_action/DD_return_action";
import { exhibitionId, serviceTypeId, toastError, contractorListActionId, toastSuccess, HallZoneActionId, HallListActionId, HallZoneListActionId } from "../../../utils/constants";
import Select from 'react-select';
import Modal from "react-modal";
import { data } from "jquery";
// import 'bootstrap-icons/font/bootstrap-icons.css';
import DatePicker from "react-datepicker";
import {
    contactNoValidator,
    panNoValidator,
    tanNoValidator,
    gstNoValidator,
    emailValidator,
} from "../../../utils/Validator";
import Resizer from "react-image-file-resizer";
import ImageCapture from '../../../utils/ImageCapture';

class DDReturnUpdate extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            isImageModal: false,

            ExhDetailsCompany: '',
            ExhDetailsHall: '',
            ExhDetailsNo: '',
            ExhDetailsEmail: '',
            VendorDetailsCompany: '',
            VendorDetailsName: '',
            VendorDetailsNo: '',
            VendorDetailsEmail: '',
            ExhStallPossessionVendorDDdetailsID: '',
            DDNo: '',
            DDDate: '',
            DDAmount: '',
            BankName: '',
            DDSubmittedByName: '',
            DDSubmittedByEmail: '',
            DDSubmittedByMob: '',
            DDSubmittedByCompany: '',

            DDReturnToName: '',
            DDReturnToEmail: '',
            DDReturnToMob: '',
            DDReturnToCompany: '',
            DDReturnToDocPath: '',
            DDReturnToDocName: '',

            SameAsAbove: false,
            DDReturnedToName: '',
            DDReturnedToEmail: '',
            DDReturnedToMob: '',
            DDReturnedToCompany: '',
            DDReturnedToDocPath: '',
            DDReturnedToDocName: '',
            DDReturnedToDocFile: '',
            DDReturnedToDocType: '',


            DDReturnedToNameErr: '',
            DDReturnedToEmailErr: '',
            DDReturnedToMobErr: '',
            DDReturnedToCompanyErr: '',
            DDReturnedToDocErr: '',

            isReturned: false,
            loginAccesslist: [],
        }
        this.emailcheck = this.emailcheck.bind(this)
        this.UpdateDD = this.UpdateDD.bind(this)
        this.SameAsAboveClick = this.SameAsAboveClick.bind(this)
        this.cancelhandle = this.cancelhandle.bind(this)
        this.onFilePick = this.onFilePick.bind(this)
        this.resizeFile = this.resizeFile.bind(this)
        this.onCrossClick = this.onCrossClick.bind(this)
        this.handleCapture = this.handleCapture.bind(this)
        this.onPdfSelect = this.onPdfSelect.bind(this)
        this.maxLengthCheck = this.maxLengthCheck.bind(this)


    }
    componentDidMount() {
        this.setState({ loginAccesslist: JSON.parse(sessionStorage.getItem('loginDataSS'))['loginAccesslist'] })
        const { exhibitionID, exhRegistrationID } = this.state
        // Fetching DropDown Fill List On Component Load
        if (this.props.location.state != null && this.props.location.state.ExhStallPossessionVendorDDdetailsID != null && this.props.location.state.ExhStallPossessionVendorDDdetailsID != undefined) {
            this.setState({
                ExhStallPossessionVendorDDdetailsID: this.props.location.state.ExhStallPossessionVendorDDdetailsID,
                isReturned: this.props.location.state.status == 1,
                EmpanelVendorDDdetailsID: this.props.location.state.EmpanelVendorDDdetailsID
            })
            this.getDDreturnDetails(this.props.location.state.ExhStallPossessionVendorDDdetailsID, this.props.location.state.EmpanelVendorDDdetailsID)
        }
    }

    getDDreturnDetails(id, EmpanelVendorDDdetailsID) {
        const { isLoading, DDreturnListArr, hallList, zoneList, currentPage, HallId, ZoneId, ExhRegistrationNo, CompanyName, vendorName, DDno, DDdate } = this.state
        this.setState({ isLoading: true })
        this.props.getDDReturnDetails_action(id, EmpanelVendorDDdetailsID)
            .then((data) => {
                if (data.error != 1) {
                    // if (data.data.length > 0) {
                    if (data.data[0].length > 0) {
                        this.setState({
                            ExhDetailsCompany: data.data[0][0].ExhibitorCompanyName,
                            ExhDetailsHall: `${data.data[0][0].HallName}/${data.data[0][0].StallName}`,
                            ExhDetailsNo: data.data[0][0].ExhibitorMobileNo,
                            ExhDetailsEmail: data.data[0][0].ExhibitorEmail,
                            VendorDetailsCompany: data.data[0][0].VendorCompanyName,
                            VendorDetailsName: data.data[0][0].VendorPersonName,
                            VendorDetailsNo: data.data[0][0].VendorMobileNo,
                            VendorDetailsEmail: data.data[0][0].VendorEmailID,

                            DDNo: data.data[0][0].DD_Number,
                            DDDate: data.data[0][0].DD_Date,
                            DDAmount: data.data[0][0].DD_Amount,
                            BankName: data.data[0][0].BankName,

                            DDSubmittedByName: '',
                            DDSubmittedByEmail: '',
                            DDSubmittedByMob: '',
                            DDSubmittedByCompany: '',
                        })
                    }
                    if (data.data[1].length > 0) {
                        this.setState({
                            DDSubmittedByName: data.data[1][0].PersonName,
                            DDSubmittedByEmail: data.data[1][0].Email,
                            DDSubmittedByMob: data.data[1][0].MobileNo,
                            DDSubmittedByCompany: data.data[1][0].CompanyName,
                        })
                    }
                    if (data.data[2].length > 0) {
                        var filePath = data.data[2][0]['PhotoID']
                        var array = data.data[2][0]['PhotoID'] != null &&
                            data.data[2][0]['PhotoID'] != "" && filePath.split("/")
                        const FileName = array[array.length - 1]
                        this.setState({
                            DDReturnToDocPath: filePath,
                            DDReturnToDocName: FileName
                        })
                        this.setState({
                            DDReturnToName: data.data[2][0].PersonName,
                            DDReturnToEmail: data.data[2][0].Email,
                            DDReturnToMob: data.data[2][0].MobileNo,
                            DDReturnToCompany: data.data[2][0].CompanyName,
                            // DDReturnToDocPath: data.data[2][0].PhotoID,
                        })
                    }
                    if (data.data[3].length > 0) {
                        var filePath = data.data[3][0]['PhotoID']
                        var array = data.data[3][0]['PhotoID'] != null &&
                            data.data[3][0]['PhotoID'] != "" && filePath.split("/")
                        const FileName = array[array.length - 1]
                        this.setState({
                            DDReturnedToDocPath: filePath,
                            DDReturnedToDocName: FileName
                        })
                        this.setState({
                            DDReturnedToName: data.data[3][0].PersonName,
                            DDReturnedToEmail: data.data[3][0].Email,
                            DDReturnedToMob: data.data[3][0].MobileNo,
                            DDReturnedToCompany: data.data[3][0].CompanyName,
                            // DDReturnedToDocPath: data.data[3][0].PhotoID,
                        })
                    }
                    this.setState({ isLoading: false })

                    // }
                } else {
                    toastError('something went wrong...')
                    this.setState({ isLoading: false })

                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    SameAsAboveClick() {
        const { isLoading, isOpen, ExhDetailsCompany, ExhDetailsHall, ExhDetailsNo, ExhDetailsEmail, VendorDetailsCompany, VendorDetailsName, VendorDetailsNo, VendorDetailsEmail, DDNo, DDDate, DDAmount, BankName, DDSubmittedByName, DDSubmittedByEmail, DDSubmittedByMob, DDSubmittedByCompany, DDReturnToName, DDReturnToEmail, DDReturnToMob, DDReturnToCompany, DDReturnToDocPath, SameAsAbove, DDReturnedToName, DDReturnedToEmail, DDReturnedToMob, DDReturnedToCompany, DDReturnedToDocPath, DDReturnedToDocName, DDReturnedToDocFile, DDReturnedToDocType, DDReturnedToNameErr, DDReturnedToEmailErr, DDReturnedToMobErr, DDReturnedToCompanyErr, DDReturnedToDocErr, ExhStallPossessionVendorDDdetailsID, DDReturnToDocName } = this.state
        if (!SameAsAbove) {
            this.setState({
                DDReturnedToName: DDReturnToName, DDReturnedToEmail: DDReturnToEmail, DDReturnedToMob: DDReturnToMob, DDReturnedToCompany: DDReturnToCompany, DDReturnedToDocPath: DDReturnToDocPath, DDReturnedToDocName: DDReturnToDocName, SameAsAbove: true, DDReturnedToNameErr: '', DDReturnedToEmailErr: '', DDReturnedToMobErr: '', DDReturnedToCompanyErr: '', DDReturnedToDocErr: '',
            })
        } else {
            this.setState({
                DDReturnedToName: '', DDReturnedToEmail: '', DDReturnedToMob: '', DDReturnedToCompany: '', DDReturnedToDocPath: '', DDReturnedToDocName: '',
                SameAsAbove: false, DDReturnedToNameErr: '', DDReturnedToEmailErr: '', DDReturnedToMobErr: '', DDReturnedToCompanyErr: '', DDReturnedToDocErr: '',
            })
        }
    }

    UpdateDD() {
        const { isLoading, isOpen, ExhDetailsCompany, ExhDetailsHall, ExhDetailsNo, ExhDetailsEmail, VendorDetailsCompany, VendorDetailsName, VendorDetailsNo, VendorDetailsEmail, DDNo, DDDate, DDAmount, BankName, DDSubmittedByName, DDSubmittedByEmail, DDSubmittedByMob, DDSubmittedByCompany, DDReturnToName, DDReturnToEmail, DDReturnToMob, DDReturnToCompany, DDReturnToDocPath, SameAsAbove, DDReturnedToName, DDReturnedToEmail, DDReturnedToMob, DDReturnedToCompany, DDReturnedToDocPath, DDReturnedToDocName, DDReturnedToDocFile, DDReturnedToDocType, DDReturnedToNameErr, DDReturnedToEmailErr, DDReturnedToMobErr, DDReturnedToCompanyErr, DDReturnedToDocErr, ExhStallPossessionVendorDDdetailsID, DDReturnToDocName } = this.state
        var err = false
        if (DDReturnedToName == '' || DDReturnedToName == null) {
            this.setState({ DDReturnedToNameErr: 'Please Enter Person Name' })
            err = true
        }
        if (DDReturnedToEmail == '' || DDReturnedToEmail == null) {
            this.setState({ DDReturnedToEmailErr: 'Please Enter Email' })
            err = true
        }
        if (DDReturnedToMob == '' || DDReturnedToMob == null) {
            this.setState({ DDReturnedToMobErr: 'Please Enter Mobile No' })
            err = true
        }
        if (DDReturnedToCompany == '' || DDReturnedToCompany == null) {
            this.setState({ DDReturnedToCompanyErr: 'Please Enter Company Name' })
            err = true
        }
        if (SameAsAbove) {
            if (DDReturnedToDocPath == '' || DDReturnedToDocPath == null) {
                this.setState({ DDReturnedToDocErr: 'Please upload Document' })
                err = true
            }
        } else {
            if (DDReturnedToDocType == '' || DDReturnedToDocType == null) {
                this.setState({ DDReturnedToDocErr: 'Please upload Document' })
                err = true
            }
        }
        if (!err) {
            this.setState({ isLoading: true })
            this.props.updateDDReturn_action(ExhStallPossessionVendorDDdetailsID, DDReturnedToName, DDReturnedToEmail, DDReturnedToMob, DDReturnedToCompany, DDReturnedToDocName, DDReturnedToDocPath, DDReturnedToDocType, DDReturnedToDocFile, { DDno: DDNo })
                .then((data) => {
                    if (data.error != 1) {
                        // if (data.data.length > 0) {
                        // if (data.data[0].length > 0) {
                        // this.setState({ DDreturnListArr: data.data, })
                        // }
                        this.setState({ isLoading: false })
                        // }
                        toastSuccess("Marked as Returned Successfully")
                        setTimeout(() => {
                            this.props.navigate('/ddReturnList')
                        }, 1000);
                        // this.setState({ isLoading: false })
                    } else {
                        toastError('something went wrong...')
                        this.setState({ isLoading: false })
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        } else {
            toastError("Enter Mandatory fields")
        }
    }

    emailcheck(value) {
        var emailErr = emailValidator(value)
        if (emailErr) { this.setState({ DDReturnedToEmailErr: emailErr }) }
    }

    cancelhandle() {
        this.props.navigate('/ddReturnList')

    }

    onFilePick = async (e, file) => {
        e.preventDefault()
        const { } = this.state
        console.log('file', file)
        if (file.length != 0) {
            if (file[0]['size'] >= 5 * 1024 * 1024) {
                toastError('File size more than 5mb are not allow.')
            } else {
                var image = '';
                if (file[0]['name'].toString().toLowerCase().includes('.pdf') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpeg') ||
                    file[0]['name'].toString().toLowerCase().includes('.png') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpg')
                ) {
                    if (file[0]['name'].toString().toLowerCase().trim().includes('.jpg') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.png') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.jpeg')
                    ) {
                        image = await this.resizeFile(file[0]);
                        this.setState({ DDReturnedToDocFile: image, DDReturnedToDocName: file[0]['name'].toString() })
                    }
                    else if (file[0]['name'].toString().toLowerCase().trim().includes('.pdf')) {
                        image = await this.onPdfSelect(file[0]);
                        this.setState({ DDReturnedToDocFile: image, DDReturnedToDocName: file[0]['name'].toString() })
                    }
                    var fileType = file[0]['type']
                    var fileTypeList;
                    if (fileType.includes("/")) {
                        fileTypeList = fileType.split("/")

                    }
                    this.setState({ DDReturnedToDocType: fileTypeList.length > 0 ? fileTypeList[1] : "", DDReturnedToDocErr: '', })
                } else {
                    toastError('Only .pdf , .jpeg, .png, .jpg files are allowed')
                }
            }
        }
    }
    resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                500,
                600,
                'JPEG',
                80,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64",
                300,
                300,
            );
        });
    onPdfSelect = (file) =>
        new Promise((resolve) => {
            let base64;
            // FileReader function for read the file.
            let fileReader = new FileReader();
            // Onload of file read the file content
            fileReader.onload = function (fileLoadedEvent) {
                base64 = fileLoadedEvent.target.result;
                // Print data in console
                resolve(base64);
            };
            // Convert data to base64
            fileReader.readAsDataURL(file);
        });
    onCrossClick() {
        this.setState({ DDReturnedToDocFile: "", DDReturnedToDocName: "" })
        document.getElementById("fileDoc").value = ""
    }
    handleCapture = (imageData) => {
        const { VendorIndex } = this.state
        this.setState({
            DDReturnedToDocName: 'Document',
            DDReturnedToDocType: 'jpeg',
            DDReturnedToDocPath: '',
            DDReturnedToDocErr: '',
            DDReturnedToDocFile: imageData,

        })
        this.setState({ isImageModal: false })
    };



    renderNewImage = (img, type) => {
        const { imageBase64 } = this.state;
        if (type == 'pdf') {
            // window.open(img, "_blank")

            const base64 = img;
            const pdfData = atob(base64.split(",")[1]); // decode Base64

            const len = pdfData.length;
            const uintArray = new Uint8Array(new ArrayBuffer(len));
            for (let i = 0; i < len; i++) {
                uintArray[i] = pdfData.charCodeAt(i);
            }

            const blob = new Blob([uintArray], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);

            window.open(url, "_blank"); // open in new tab

        } else {
            const newWindow = window.open();
            if (newWindow) {
                newWindow.document.write(
                    `<img src="${img}" style="width:100%;height:auto;" />`
                );
            } else {
                alert("Please allow popups for this website");
            }
        }
    };


    maxLengthCheck = (object, maxLength) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(
                0,
                object.target.maxLength
            );
        }
    };

    getUpdateAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '9' || item.ModuleID == '41');
        if (moduleAccess) {
            return moduleAccess.UpdateAccess;
        } else {
            return false
        }
        return false;
    }

    render() {
        const { isLoading, isImageModal, isReturned, isOpen, ExhDetailsCompany, ExhDetailsHall, ExhDetailsNo, ExhDetailsEmail, VendorDetailsCompany, VendorDetailsName, VendorDetailsNo, VendorDetailsEmail, DDNo, DDDate, DDAmount, BankName, DDSubmittedByName, DDSubmittedByEmail, DDSubmittedByMob, DDSubmittedByCompany, DDReturnToName, DDReturnToEmail, DDReturnToMob, DDReturnToCompany, DDReturnToDocPath, DDReturnToDocName, SameAsAbove, DDReturnedToName, DDReturnedToEmail, DDReturnedToMob, DDReturnedToCompany, DDReturnedToDocPath, DDReturnedToDocName, DDReturnedToDocFile, DDReturnedToDocType, DDReturnedToNameErr, DDReturnedToEmailErr, DDReturnedToMobErr, DDReturnedToCompanyErr, DDReturnedToDocErr } = this.state
        // const recordsPerPage = 10;
        // const indexOfLastRecord = currentPage * recordsPerPage;
        // const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        // const currentRecords = DDreturnList.slice(indexOfFirstRecord, indexOfLastRecord);
        // const nPages = Math.ceil(DDreturnList.length / recordsPerPage)
        var isNational = ExhDetailsNo?.slice(0, 3) == '+91'

        console.log(DDReturnedToDocType)
        return (
            <>

                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                <ToastContainer />
                <HeaderWithLogo />
                {/* <HeaderWithLogo /> */}
                <>
                    <AdminDrawer />
                    {/* <div className="app-content with-dr-container com-height"> */}

                    <div className="app-content with-dr-container com-height" style={{ minHeight: 'auto' }}>
                        <div class="row m-0"><div class="breadcrumb-scroll-fixed"><h6 class="mb-0 p-2 text-white">DD Return</h6></div></div>
                        <main id="main" class="px-3 py-2" style={{ marginTop: '6rem' }}>
                            <section class="section p-0">
                                <div class="row mt-4">
                                    <div class="col-md-6">
                                        <div class="card shadow-none border rounded-3 mb-3 p-0">
                                            <div class="card-header py-2 px-3">
                                                <i class="ri-information-line grid-icon me-2 "></i> Exhibitor's Details
                                            </div>
                                            <div class="card-body d-flex align-items-center py-3 px-3 flex-wrap">
                                                <div class="d-flex align-items-center me-4">
                                                    {ExhDetailsCompany != '' && ExhDetailsCompany != null && <i class="ri-hotel-line grid-icon me-1 fs-6"></i>}
                                                    <span class=" text-dark">{ExhDetailsCompany}</span>
                                                </div>
                                                <div class="d-flex align-items-center me-4">
                                                    {ExhDetailsHall != '' && ExhDetailsHall != null && <i class="ri-ticket-2-line grid-icon me-1 fs-6"></i>}
                                                    <span class=" text-muted">{ExhDetailsHall}</span>
                                                </div>
                                                <div class="d-flex align-items-center me-4">
                                                    {ExhDetailsNo != '' && ExhDetailsNo != null && <i class="ri-phone-line grid-icon me-1 fs-6"></i>}
                                                    <span class="fw-normal text-muted">{ExhDetailsNo}</span>
                                                </div>
                                                <div class="d-flex align-items-center">
                                                    {ExhDetailsEmail != '' && ExhDetailsEmail != null && <i class="ri-mail-line grid-icon me-1 fs-6"></i>}
                                                    <span class="fw-normal text-muted">{ExhDetailsEmail}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="card shadow-none border rounded-3 mb-3 p-0">
                                            <div class="card-header d-flex justify-content-between align-items-center py-2 px-3" >
                                                <div>
                                                    <i class="ri-user-line me-2 grid-icon"></i>
                                                    Service Partner's Details
                                                </div>
                                                <span class="badge px-3 py-1 rounded-pill" style={{ backgroundColor: '#51cbc0' }}>Non-Empanel</span>
                                            </div>
                                            <div class="card-body d-flex align-items-center py-3 px-3 flex-wrap">
                                                <div class="d-flex align-items-center me-4">
                                                    {VendorDetailsCompany != '' && VendorDetailsCompany != null && <i class="ri-hotel-line grid-icon me-1 fs-6"></i>}
                                                    <span class=" text-dark">{VendorDetailsCompany}</span>
                                                </div>

                                                <div class="d-flex align-items-center me-4">
                                                    {VendorDetailsName != '' && VendorDetailsName != null && <i class="ri-user-3-line text-secondary me-1 fs-6"></i>}
                                                    <span class=" text-muted">{VendorDetailsName}</span>
                                                </div>

                                                <div class="d-flex align-items-center me-4">
                                                    {VendorDetailsNo != '' && VendorDetailsNo != null && <i class="ri-phone-line grid-icon me-1 fs-6"></i>}
                                                    <span class="fw-normal text-muted">{VendorDetailsNo}</span>
                                                </div>
                                                <div class="d-flex align-items-center">
                                                    {VendorDetailsEmail != '' && VendorDetailsEmail != null && <i class="ri-mail-line grid-icon me-1 fs-6"></i>}
                                                    <span class="fw-normal text-muted">{VendorDetailsEmail}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="">

                                    <div
                                        class="shadow-none border-1 rounded-3 mb-3"
                                        style={{ border: "1px solid #ced4da" }}
                                    >
                                        <div
                                            class="card-header py-2 fw-semibold"
                                        >
                                            DD Details
                                        </div>
                                        <div class="card-body border p-1 pt-0" id="submittedSection">
                                            <div class="row g-2 p-1 mb-3 mt-0 pt-0 pb-0">
                                                <div class="col-md-3">
                                                    <label for="ddNo" class="form-label fw-normal">DD Number<span class="text-danger">*</span></label>
                                                    <input type="text" class="form-control" id="ddNo" placeholder="" value={DDNo} disabled />
                                                </div>

                                                <div class="col-md-3">
                                                    <label for="ddDate" class="form-label fw-normal">DD Date<span class="text-danger">*</span></label>
                                                    <DatePicker className="form-control"
                                                        dateFormat="dd-MM-yyyy"
                                                        selected={DDDate != '' && DDDate != null ? new Date(DDDate) : ''}
                                                        // onChange={(e) => this.onExpiryAUChange(e)}
                                                        // onChange={(e) => this.setState({
                                                        //     DDdate: e
                                                        // })}
                                                        // value={Da} 
                                                        disabled
                                                        // maxDate={new Date(ToDate)}
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        placeholderText="dd-mm-yyyy"
                                                    />
                                                    {/* <input type="date" class="form-control" id="ddDate" /> */}
                                                </div>

                                                <div class="col-md-3">
                                                    <label for="ddAmount" class="form-label fw-normal">DD Amount<span class="text-danger">*</span></label>
                                                    <input type="number" class="form-control" id="ddAmount" placeholder="" value={DDAmount} disabled />
                                                </div>

                                                <div class="col-md-3">
                                                    <label for="bankName" class="form-label fw-normal">Bank Name<span class="text-danger">*</span></label>
                                                    <input type="text" class="form-control" id="bankName" placeholder="" value={BankName} disabled />
                                                </div>
                                            </div>

                                            <div class="mt-3">
                                                <div
                                                    class="shadow-none border-1 rounded-3 mb-3"
                                                    style={{ border: "1px solid #ced4da" }}
                                                >
                                                    <div
                                                        class="card-header fw-semibold py-2"
                                                    >
                                                        DD Submitted By
                                                    </div>
                                                    <div class="card-body p-0" id="submittedSection">
                                                        <div class="border-0 rounded p-2 mb-0">
                                                            <div class="row g-2">
                                                                <div class="col-md-3">
                                                                    <label class="form-label fw-normal mb-1">Person Name</label>
                                                                    <input type="text" class="form-control form-control-sm w-100" value={DDSubmittedByName} disabled />
                                                                </div>
                                                                <div class="col-md-3">
                                                                    <label class="form-label fw-normal mb-1">Email</label>
                                                                    <input type="email" class="form-control form-control-sm w-100" value={DDSubmittedByEmail} disabled />
                                                                </div>
                                                                <div class="col-md-3">
                                                                    <label class="form-label fw-normal mb-1">Mobile No</label>
                                                                    <input type="text" class="form-control form-control-sm w-100" value={DDSubmittedByMob} disabled />
                                                                </div>
                                                                <div class="col-md-3">
                                                                    <label class="form-label fw-normal mb-1">Company Name</label>
                                                                    <input type="text" class="form-control form-control-sm w-100" value={DDSubmittedByCompany} disabled />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div
                                                    class="shadow-none border-1 rounded-3 mb-3"
                                                    style={{ border: "1px solid #ced4da" }}
                                                >
                                                    <div
                                                        class="card-header fw-semibold py-2"
                                                    >
                                                        DD Return To <span class="">( As mentioned during dd submission )</span>
                                                    </div>
                                                    <div class="card-body p-0" id="returnedSection">
                                                        <div class="border-0 rounded p-2 mb-none">
                                                            <div class="row g-2">

                                                                <div class="col-md-3">
                                                                    <label class="form-label fw-normal mb-1">Person Name</label>
                                                                    <input type="text" class="form-control form-control-sm w-100" value={DDReturnToName} disabled />
                                                                </div>
                                                                <div class="col-md-3">
                                                                    <label class="form-label fw-norma mb-1">Email</label>
                                                                    <input type="email" class="form-control form-control-sm w-100" value={DDReturnToEmail} disabled />
                                                                </div>
                                                                <div class="col-md-3">
                                                                    <label class="form-label fw-normal mb-1">Mobile No</label>
                                                                    <input type="text" class="form-control form-control-sm w-100" value={DDReturnToMob} disabled />
                                                                </div>
                                                                <div class="col-md-3">
                                                                    <label class="form-label fw-normal mb-1">Company Name</label>
                                                                    <input type="text" class="form-control form-control-sm w-100" value={DDReturnToCompany} disabled />
                                                                </div>
                                                            </div>

                                                            <div class="card shadow-none border-0 mt-1 mb-0 text-left">
                                                                <div class="text-dark py-2 fw-bold text-muted">
                                                                    Photo ID <small>(Government Approved Document)</small>
                                                                </div>
                                                                <div class="card-body border rounded p-2">
                                                                    <div style={{
                                                                        border: '1px solid #ced4da',
                                                                        padding: '10px',
                                                                        display: 'inline-flex',
                                                                        alignItems: 'center',
                                                                        // marginTop: '10px'
                                                                    }}>
                                                                        <a
                                                                            href={DDReturnToDocPath}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                        >
                                                                            <span style={{ marginRight: '10px' }}
                                                                            >
                                                                                {/* {passportImage} */}{DDReturnToDocName}
                                                                            </span>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div
                                                    class="shadow-none border-1 rounded-3 mb-3"
                                                    style={{ border: "1px solid #ced4da" }}
                                                >
                                                    <div
                                                        class="card-header fw-semibold py-2"
                                                    >
                                                        DD Returned To
                                                    </div>
                                                    <div class="mt-3 ms-2"> <label class="d-flex"><input type="checkbox" class="mr-2 m-1 me-2" disabled={isReturned} checked={SameAsAbove} value={SameAsAbove} onClick={this.SameAsAboveClick} />Same as above</label>
                                                    </div>
                                                    <div class="card-body p-0" id="returnedSection">
                                                        <div class="border-0 rounded p-2 mb-none">
                                                            <div class="row g-2">
                                                                <div class="col-md-3">
                                                                    <label class="form-label fw-normal mb-1">Person Name</label>
                                                                    <input type="text" class="form-control form-control-sm w-100" disabled={SameAsAbove || isReturned} value={DDReturnedToName} onChange={(e) => this.setState({ DDReturnedToName: e.target.value, DDReturnedToNameErr: '' })} />
                                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                                        {DDReturnedToNameErr}
                                                                    </span>
                                                                </div>
                                                                <div class="col-md-3">
                                                                    <label class="form-label fw-normal mb-1">Email</label>
                                                                    <input type="email" class="form-control form-control-sm w-100" disabled={SameAsAbove || isReturned} value={DDReturnedToEmail} onChange={(e) => this.setState({ DDReturnedToEmail: e.target.value, DDReturnedToEmailErr: '' })} onBlur={(e) => this.emailcheck(e.target.value)} />
                                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                                        {DDReturnedToEmailErr}
                                                                    </span>
                                                                </div>
                                                                <div class="col-md-3">
                                                                    <label class="form-label fw-normal mb-1">Mobile No</label>
                                                                    <input type="text" class="form-control form-control-sm w-100" maxLength={10}
                                                                        onInput={(e) => this.maxLengthCheck(e, isNational ? 10 : 20)}

                                                                        disabled={SameAsAbove || isReturned} value={DDReturnedToMob} onChange={(e) => this.setState({ DDReturnedToMob: e.target.value.length > 0 ? /^\d$/.test(e.target.value[e.target.value.length - 1]) && e.target.value.length < 11 ? e.target.value : '' : '', DDReturnedToMobErr: '' })} />
                                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                                        {DDReturnedToMobErr}
                                                                    </span>
                                                                </div>
                                                                <div class="col-md-3">
                                                                    <label class="form-label fw-normal mb-1">Company Name</label>
                                                                    <input type="text" class="form-control form-control-sm w-100" disabled={SameAsAbove || isReturned} value={DDReturnedToCompany} onChange={(e) => this.setState({ DDReturnedToCompany: e.target.value, DDReturnedToCompanyErr: '' })} />
                                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                                        {DDReturnedToCompanyErr}
                                                                    </span>
                                                                </div>
                                                            </div>

                                                            <div class="card shadow-none border-0 mt-1 mb-0 text-left">
                                                                <div class="text-dark py-2 fw-bold text-muted">
                                                                    Photo ID <small>(Government Approved Document)</small>
                                                                </div>
                                                                <div class="card-body border rounded p-2">
                                                                    <div class="row g-2 align-items-center">
                                                                        <div class="col-md-6">
                                                                            <label class="form-label fw-normal mb-1">Capture / Upload Photo</label>
                                                                            {DDReturnedToDocName != null && DDReturnedToDocName != '' ? <div style={{
                                                                                border: '1px solid #ced4da',
                                                                                padding: '10px',
                                                                                display: 'inline-flex',
                                                                                alignItems: 'center',
                                                                            }}>
                                                                                <a
                                                                                    href={DDReturnedToDocPath}
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                >
                                                                                    {DDReturnedToDocType != null && DDReturnedToDocType != '' ? <span onClick={() => this.renderNewImage(DDReturnedToDocFile, DDReturnedToDocType)} style={{ marginRight: '10px', cursor: 'pointer' }}
                                                                                    >{DDReturnedToDocName}</span> : <span style={{ marginRight: '10px' }}
                                                                                    >{DDReturnedToDocName}</span>}
                                                                                </a>
                                                                                {isReturned ? <></> : !SameAsAbove && <i className={`fa fa-times text-danger img-can`}
                                                                                    onClick={(e) => this.setState({ DDReturnedToDocFile: '', DDReturnedToDocType: '', DDReturnedToDocName: '', DDReturnedToDocPath: '' })}
                                                                                ></i>}
                                                                            </div>
                                                                                : <div class="d-flex align-items-center gap-2 m-0">
                                                                                    {!SameAsAbove && <button class="btn btn-aqua d-flex align-items-center" style={{ height: '27px' }} onClick={() => this.setState({ isImageModal: true })}>
                                                                                        <i class="bi bi-camera me-1"></i> Open Camera
                                                                                    </button>}
                                                                                    {!SameAsAbove && <span class="text-muted">or</span>}
                                                                                    {!SameAsAbove && <div className="upload-options">
                                                                                        <label className="d-flex align-items-center gap-2 m-0">
                                                                                            <input
                                                                                                type="file"
                                                                                                id="fileDoc"
                                                                                                ref="fileDoc"
                                                                                                name="fileDoc"
                                                                                                className="image-upload mt-2"
                                                                                                accept=".jpg,.jpeg,.png,.pdf"
                                                                                                onChange={e => this.onFilePick(e, e.target.files)}
                                                                                            />

                                                                                            <span className="text-danger small text-nowrap">
                                                                                                Max 5MB | Pdf, Jpeg, Jpg, Png only
                                                                                            </span>
                                                                                        </label>

                                                                                    </div>}
                                                                                </div>}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <span className="text-danger text-start text-left d-block mt-1">
                                                                    {DDReturnedToDocErr}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="mb-2 text-end p-0 mt-2">
                                    {!isReturned && <button class="btn btn-aqua px-3 p-1" disabled={!this.getUpdateAccess()} onClick={() => this.UpdateDD()}>Mark as DD Returned</button>}
                                    <button class="btn btn-gray px-2 p-1 mx-2" onClick={() => this.cancelhandle()}>Back</button>
                                </div>
                            </section>
                        </main>
                    </div>
                </>
                <ImageCapture
                    isOpen={isImageModal}
                    onClose={() => this.setState({ isImageModal: false })}
                    onCapture={this.handleCapture}
                />
            </>)
    }
}

export default withRouter(connect(null, {
    fill_action, getDDReturnDetails_action, updateDDReturn_action
    // getDDReturnList_action
})(DDReturnUpdate));